import React from "react"
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap"
import { plural } from "pages/EventsManagement/components/Tabs/Logistics/labels"
import { changedFields, dateRange, impactLabel } from "./productLabels"

// The impact analysis of a catalogue change (US 142), shown before a change that reaches the sheets in
// preparation is applied: each sheet with its event's dates and organizer, and its lines that change or
// keep an administrator's value. Confirming sends the change with the preview's revision.
// "Changing the default supplier of <product> changes 1 unshipped sheet.", as in the prototype; a new
// product is "Adding <product>".
export default function ImpactDialog({ impact, pending, failure, onConfirm, onCancel }) {
  const { stored, product, preview: { sheets, totals } } = impact
  const close = pending ? undefined : onCancel
  const change = stored ? `Changing the ${changedFields(stored, product) || "details"} of ` : "Adding "
  return <Modal isOpen size="lg" centered toggle={close} labelledBy="logistics-impact-title">
    <ModalHeader id="logistics-impact-title" toggle={close}>Impact on unshipped sheets</ModalHeader>
    <ModalBody>
      <p>
        {change}<b>{product.name}</b>{` changes ${totals.sheets ? plural(totals.sheets, "unshipped sheet") : "no unshipped sheet"}.`}
        {totals.kept > 0 && ` ${plural(totals.kept, "line")} ${totals.kept === 1 ? "keeps" : "keep"} a supplier or quantity set by an administrator.`}
      </p>
      <Table className="logistics-stack mb-2">
        <thead><tr><th>Event</th><th>Organizer</th><th>Lines</th></tr></thead>
        <tbody>{sheets.map(sheet => <tr key={sheet.eventId}>
          <td><div>{sheet.name}</div><div className="small text-muted">{dateRange(sheet.startDate, sheet.endDate, sheet.timezone || undefined)}</div></td>
          <td data-label="Organizer">{sheet.organizer?.name || "No organizer"}</td>
          <td data-label="Lines">{sheet.lines.map(line => <div key={line.line} className={line.changes.length ? "" : "text-muted"}>
            <i className={`bx ${line.changes.length ? "bx-transfer-alt text-warning" : "bx-lock-alt"} mr-1`} aria-hidden="true" />
            <span>{impactLabel(line)}</span>
          </div>)}</td>
        </tr>)}</tbody>
      </Table>
      <p className="small text-muted mb-0">Shipped sheets never change. The change and each line it changes are logged.</p>
      {failure && <Alert color="danger" className="mt-3 mb-0">{failure}</Alert>}
    </ModalBody>
    <ModalFooter>
      <Button color="light" disabled={pending} onClick={onCancel}>Cancel</Button>
      <Button color="primary" disabled={pending} onClick={onConfirm}>{pending ? "Applying…" : "Confirm and apply"}</Button>
    </ModalFooter>
  </Modal>
}
